import { render, staticRenderFns } from "./RequestToken.vue?vue&type=template&id=52f494c0&scoped=true&"
import script from "./RequestToken.vue?vue&type=script&lang=js&"
export * from "./RequestToken.vue?vue&type=script&lang=js&"
import style0 from "./RequestToken.vue?vue&type=style&index=0&id=52f494c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f494c0",
  null
  
)

export default component.exports